import NotFoundPage from './NotFoundPage.js';

export default NotFoundPage;
